import { render, staticRenderFns } from "./TopMenuSearch.vue?vue&type=template&id=2ff86070&scoped=true&"
import script from "./TopMenuSearch.vue?vue&type=script&setup=true&lang=js&"
export * from "./TopMenuSearch.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff86070",
  null
  
)

export default component.exports